import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=512e2692&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=512e2692&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e2692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512e2692')) {
      api.createRecord('512e2692', component.options)
    } else {
      api.reload('512e2692', component.options)
    }
    module.hot.accept("./PurchaseOrderDetail.vue?vue&type=template&id=512e2692&scoped=true", function () {
      api.rerender('512e2692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderDetail.vue"
export default component.exports